import { createSelector } from 'reselect';
import {
    getCandybarItemEntities,
    getCheckoutOrderCandybar,
    getCheckoutCandybarOrderTotal,
    getCheckoutCinema,
    getCheckoutGrandTotal,
    getCheckoutMovie,
    getCheckoutOrderSeatsLabels,
    getCheckoutOrderTicketsCount,
    getCheckoutOrderTicketsSeatsCount,
    getCheckoutSelectedMethodGrandTotalString,
    getCheckoutSelectedPaymentOptionBookingFee,
    getCheckoutSelectedTicketsString,
    getCheckoutSession,
    getCheckoutTicketsTotal, 
    getCheckoutStep,
    getCheckoutTicketsWithQuantity,
} from '../reducers';
import { CinemaType, MovieType, SessionType } from '../types/entities';
import { getCheckoutCouponCode } from '../reducers/checkoutData';

export const orderSummaryData: (state: any) => {
    bookingFee: number;
    candybarAmount: number;
    candybarCatalog: any;
    candybarOrder: any;
    cinema: CinemaType;
    couponCode: string;
    currentStep: string;
    grandTotal: number;
    grandTotalPaymentString: string;
    movie: MovieType | null;
    session: SessionType | null;
    ticketsOrder: Array<any>;
    ticketsSeatsCount: number;
    ticketsString: string;
    ticketsSum: number;
    ticketsAmount: number;
    seatsLabels: Array<string>;
} = createSelector(
    [
        getCheckoutSelectedPaymentOptionBookingFee,
        getCheckoutCandybarOrderTotal,
        getCandybarItemEntities,
        getCheckoutOrderCandybar,
        getCheckoutCinema,
        getCheckoutCouponCode,
        getCheckoutStep,
        getCheckoutGrandTotal,
        getCheckoutSelectedMethodGrandTotalString,
        getCheckoutMovie,
        getCheckoutSession,
        getCheckoutTicketsWithQuantity,
        getCheckoutOrderTicketsSeatsCount,
        getCheckoutSelectedTicketsString,
        getCheckoutOrderTicketsCount,
        getCheckoutTicketsTotal,
        getCheckoutOrderSeatsLabels,
    ],
    (
        bookingFee,
        candybarAmount,
        candybarCatalog,
        candybarOrder,
        cinema,
        couponCode,
        currentStep,
        grandTotal,
        grandTotalPaymentString,
        movie,
        session,
        ticketsOrder,
        ticketsSeatsCount,
        ticketsString,
        ticketsSum,
        ticketsAmount,
        seatsLabels,
    ) => ({
        bookingFee,
        candybarAmount,
        candybarCatalog,
        candybarOrder,
        cinema,
        couponCode,
        currentStep,
        grandTotal,
        grandTotalPaymentString,
        movie,
        session,
        ticketsOrder: ticketsOrder.filter(ticket => ticket.qty > 0),
        ticketsSeatsCount,
        ticketsString,
        ticketsSum,
        ticketsAmount,
        seatsLabels,
    })
);
